import { documentTypeCalculationFieldApi } from 'app/services/api';
import { normalize, schema } from 'normalizr';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const DOCUMENT_CALCULATION_FIELDS_TYPE = createNamedActions('documentCalculationFields', {
  GET_DOCUMENT_CALCULATION_FIELDS_TYPE: 'GET_DOCUMENT_CALCULATION_FIELDS_TYPE',
  ADD_DOCUMENT_CALCULATION_FIELDS_TYPE: 'ADD_DOCUMENT_CALCULATION_FIELDS_TYPE',
  EDIT_DOCUMENT_CALCULATION_FIELDS_TYPE: 'EDIT_DOCUMENT_CALCULATION_FIELDS_TYPE',
  DELETE_DOCUMENT_CALCULATION_FIELDS_TYPE: 'DELETE_DOCUMENT_CALCULATION_FIELDS_TYPE',
});

const documentCalculationFields = new schema.Entity(
  'documentCalculationFields',
  {},
  { idAttribute: 'id' },
);

export const getDocumentCalculationFieldsAction = catchAsyncActionError(
  params => async dispatch => {
    const { data } = await documentTypeCalculationFieldApi.getDocumentTypeCalculationField(params);

    return dispatch({
      type: DOCUMENT_CALCULATION_FIELDS_TYPE.GET_DOCUMENT_CALCULATION_FIELDS_TYPE,
      payload: normalize(data, [documentCalculationFields]).entities,
    });
  },
);

export const addDocumentCalculationFieldsAction = catchAsyncActionError(
  params => async dispatch => {
    const { data } =
      await documentTypeCalculationFieldApi.createDocumentTypeCalculationField(params);

    return dispatch({
      type: DOCUMENT_CALCULATION_FIELDS_TYPE.ADD_DOCUMENT_CALCULATION_FIELDS_TYPE,
      payload: data,
    });
  },
);

export const editDocumentCalculationFieldsAction = catchAsyncActionError(
  params => async dispatch => {
    const { data } = await documentTypeCalculationFieldApi.editDocumentTypeCalculationField(params);

    return dispatch({
      type: DOCUMENT_CALCULATION_FIELDS_TYPE.EDIT_DOCUMENT_CALCULATION_FIELDS_TYPE,
      payload: data,
    });
  },
);

export const deleteDocumentCalculationFieldsAction = catchAsyncActionError(
  ({ documentTypeCalculationFieldId }) =>
    async dispatch => {
      await documentTypeCalculationFieldApi.deleteDocumentTypeCalculationField({
        documentTypeCalculationFieldId,
      });

      return dispatch({
        type: DOCUMENT_CALCULATION_FIELDS_TYPE.DELETE_DOCUMENT_CALCULATION_FIELDS_TYPE,
        payload: documentTypeCalculationFieldId,
      });
    },
);
